<template>
  <div class="photos-carousel">
    <button v-show="showNavigation" type="button" class="button-prev" @click="prevSlide()">
      <i class="icon-arrow-bold-left icon-lg"></i>
    </button>

    <swiper ref="swiper" :options="swiperOptions">
      <swiper-slide v-for="(slide, index) in slides" :key="index">
        <a v-fancy-box:photos :href="slide.big">
          <img :src="slide.small" class="img-fluid" :alt="slide">
        </a>
      </swiper-slide>
    </swiper>

    <button v-show="showNavigation" type="button" class="button-next" @click="nextSlide()">
      <i class="icon-arrow-bold-right icon-lg"></i>
    </button>
  </div>
</template>

<script>
  import {
    Swiper
  } from 'swiper'

  import VueAwesomeSwiper from 'vue-awesome-swiper'

  Vue.use(VueAwesomeSwiper)

  export default {
    props: {
      slides: {
        type: Array,
        required: true,
        default: null
      }
    },
    data() {
      return {
        swiperOptions: {
          centeredSlides: false,
          simulateTouch: false,
          slidesPerView: this.slides.length < 2 ? this.slides.length : 2,
          breakpoints: {
            768: {
              slidesPerView: this.slides.length < 2 ? this.slides.length : 2
            },
            992: {
              slidesPerView: this.slides.length < 3 ? this.slides.length : 3
            },
            1200: {
              slidesPerView: this.slides.length < 4 ? this.slides.length : 4
            }
          }
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.swiper.$swiper
      },
      showNavigation() {
        return this.slides.length > 4
      }
    },
    methods: {
      prevSlide() {
        this.$refs.swiper.$swiper.slidePrev()
        // this.swiper.navigation.prevEl
      },
      nextSlide() {
        this.$refs.swiper.$swiper.slideNext()
        // this.swiper.slideNext()
      },
    }
  }
</script>

<style lang="scss">
  // @import 'src/sass/variables';
  // @import 'node_modules/bootstrap/scss/vendor/rfs';

  .photos-carousel {
    position: relative;

    .swiper-wrapper {
      .swiper-slide {
        max-width: 200px;
        margin: 0px 5px;
      }
    }

    .button-prev,
    .button-next {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
    }

    .button-prev {
      right: calc(100% + 10px);
    }

    .button-next {
      left: calc(100% + 10px);
    }
  }
</style>